<!-- *Below code is the acutal navbar. DO NOT DELETE THIS!!!!! -->
<div>
  <app-corner-branding></app-corner-branding>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        (click)="isCollapsed = !isCollapsed"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarNav"
        [ngbCollapse]="isCollapsed"
      >
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" routerLink="/Help"
              >Help</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/AdminLookup">Admin Lookup</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/ProctorLookup">Proctor Lookup</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/CourseLookup">Course Lookup</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/MyLogin">My NANTeL Login</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
